let vpsCalculatorInstance = null;
class VPSCalculator {
    constructor() {
        this.form = document.getElementById('vps-calculator');
        this.summaryBlock = document.getElementById('calc-results');
        if (!this.form) console.log('form not found')
        else console.log('form found')
        if (!this.form) return

        this.currentDiskType = null;
        this.currentConfig = null;
        this.configs = null;
        this.currency = document.getElementById('calc_base_price')?.getAttribute('data-currency')
        this.results = {
            base: 0,
            cpu: 0,
            ram: 0,
            storage: 0,
            os: 0,
            software: 0,
            administration: 0
        };
        this.summary = {
            os: '',
            po:'',
            hardware: '',
            adm: 0
        };

        this.init();
    }

    init() {
        this.loadInitialConfig();
        this.setupEventListeners();
        this.calculate();
    }

    loadInitialConfig() {
        // Загружаем первую доступную конфигурацию        
        const initialConfig = this.form.querySelector('[name="service-calc-disk"]:checked');        
        this.configs = document.getElementById('diskConfigs') ? JSON.parse(document.getElementById('diskConfigs')?.dataset.config) : null;
        if (initialConfig && this.configs) {          
            this.currentDiskType = initialConfig.value;
            this.currentConfig = this.configs[this.currentDiskType];
            
            this.updateInputAttributes();
        }
    }

    setupEventListeners() {
        // Обработчик изменения типа диска
        this.form.querySelectorAll('[name="service-calc-disk"]').forEach(radio => {
            radio.addEventListener('change', () => {
                this.currentDiskType = radio.value;
                this.currentConfig = this.configs[this.currentDiskType];
                this.updateInputAttributes();
                this.calculate();
            });
        });

        // Общие обработчики для всех полей ввода
        this.form.querySelectorAll('input, select, .js-select-ext ').forEach(input => {
            input.addEventListener('change', () => this.calculate());
            input.addEventListener('input', () => this.calculate());
        });

        // Дебаунс для полей ввода чисел
        this.form.querySelectorAll('input[type="number"]').forEach(input => {
            input.addEventListener('input', this.debounce(() => this.calculate(), 300));
        });
    }

    updateInputAttributes() {
        // Обновляем min/max/step для всех полей ввода
        ['cpu', 'ram', 'storage'].forEach(param => {
            const input = this.form.querySelector(`[name="service-calc-${param}"]`);
            if (!input) return;

            input.min = this.currentConfig[`${param}_min`];
            input.max = this.currentConfig[`${param}_max`];
            input.step = this.currentConfig[`${param}_step`];
            // Устанавливаем значение не меньше минимального
            if (parseFloat(input.value) < parseFloat(input.min)) {              
                input.value = input.min;
            }
            if (parseFloat(input.value) > parseFloat(input.max)) {              
                input.value = input.max;
            }
        });
    }

    calculate() {
        const formData = new FormData(this.form);
        const values = Object.fromEntries(formData.entries());

        this.updateSoftwareOptions(values)

        // Сбрасываем результаты
        Object.keys(this.results).forEach(key => this.results[key] = 0);

        // 1. Расчет базовой цены
        this.results.base = this.currentConfig.base_price;

        // 2. Расчет цены CPU
        this.results.cpu = this.calculateComponentPrice(
            values['service-calc-cpu'],
            'cpu',
            this.currentConfig.cpu_price_step
        );

        // 3. Расчет цены RAM
        this.results.ram = this.calculateComponentPrice(
            values['service-calc-ram'],
            'ram',
            this.currentConfig.ram_price_step
        );

        // 4. Расчет цены хранилища
        this.results.storage = this.calculateComponentPrice(
            values['service-calc-storage'],
            'storage',
            this.currentConfig.storage_price_step
        );

        // 5. Расчет ОС
        this.results.os = this.calculateOSPrice(values);

        // 6. Расчет дополнительного ПО
        this.results.software = this.calculateSoftwarePrice(values);

        // 7. Расчет администрирования
        this.results.administration = values['service-calc-adm'] === '1' 
            ? parseFloat(document.querySelector('[data-js-adm-info]').dataset.price) 
            : 0;
        if (this.results.administration > 0) {
            this.summary.adm = {
                'price': this.formatPrice(this.results.administration) + ' ' + this.currency
            };
        }
        // Итоговый расчет
        this.displayResults();
        this.updateSummary(values);
    }

    calculateComponentPrice(value, param, pricePerStep) {
        const min = this.currentConfig[`${param}_min`];
        const step = this.currentConfig[`${param}_step`];
        const steps = (value - min) / step;
        return steps * pricePerStep;
    }

    calculateOSPrice(values) {
        const osElement = document.querySelector(`[data-json-${values['service-calc-os']}]`);
        if (!osElement) return 0;
        const osData = JSON.parse(osElement.getAttribute('data-json-' + values['service-calc-os']));
        const versionId = values[`service-calc-os-version-${values['service-calc-os']}`];
        const osPrice = parseFloat(osData[versionId].price);
        const cpuCount = parseFloat(values['service-calc-cpu']);
        
        this.summary.os = {
          "title" : `${osData.pagetitle} ${osData[versionId].pagetitle}`,
          "price" : this.formatPrice(osPrice) + ' ' + this.currency
        }

        return osData.price_per_core ? osPrice * cpuCount : osPrice;
    }

    calculateSoftwarePrice(values) {
        const softwareId = values['service-calc-po'];
        if (!softwareId || softwareId === '0') {
          this.summary.po = null
          return 0
        }

        const softwareElement = document.querySelector(`input[name="service-calc-po"][value="${softwareId}"]`);
        const price = softwareElement?.dataset.price ? parseFloat(softwareElement.dataset.price) : 0;
        this.summary.po = {
          'title': softwareElement?.dataset.pagetitle,
          'price': this.formatPrice(price) + ' ' + this.currency,
        }
        return price
    }
    updateSoftwareOptions(values) {
        const osVersionId = values[`service-calc-os-version-${values['service-calc-os']}`];
        const poInputs = document.querySelectorAll('input[name="service-calc-po"]')
        poInputs.forEach(input => {    
          const osIds = input.getAttribute('data-oses') ? input.getAttribute('data-oses') : false
          if (!osIds) {
            input.disabled = false;
          } else if (osIds.includes(osVersionId)) {
            input.disabled = false;
          } else {
            input.disabled = true;
            if (input.checked) {
              input.checked = false;
              poInputs[0].checked = true;
              poInputs[0].click();
              setTimeout(() => {
                handleFormChange()
              },100)
            }
          }
        })
    }
    displayResults() {      
        // Итоговая цена
        const totalPrice = Object.values(this.results).reduce((sum, price) => sum + price, 0);
        const monthlyPrice = this.formatPrice(totalPrice);
        const dailyPrice = this.formatPrice(totalPrice * 12 / 365);

        // Обновляем UI
        document.querySelector('[data-js-day-price]').textContent = `${dailyPrice} ${this.currency}`;
        document.getElementById('calc_base_price').textContent = `${monthlyPrice} ${this.currency}`;

        // Детализированные цены
        this.updateDetailedPrices();
    }

    updateDetailedPrices() {
        // Обновляем цены компонентов
        document.querySelector('[data-js-local-cpu]').textContent = 
            `+ ${this.formatPrice(this.results.cpu)} ${this.currency}`;
            
        document.querySelector('[data-js-local-ram]').textContent = 
            `+ ${this.formatPrice(this.results.ram)} ${this.currency}`;
            
        document.querySelector('[data-js-local-storage]').textContent = 
            `+ ${this.formatPrice(this.results.storage)} ${this.currency}`;
            
        document.querySelector('[data-js-local-adm]').textContent = 
            this.results.administration > 0 
                ? `+ ${this.formatPrice(this.results.administration)} ${this.currency}`
                : '0 ' + this.currency;
    }

    updateSummary(values) {
        this.summary.hardware = {
          'title': `
              CPU x ${values['service-calc-cpu']}, 
              RAM x ${values['service-calc-ram']} Gb,
              ${values['service-calc-channel']}, 
              HDD x ${values['service-calc-storage']} Gb`,
          'price': this.formatPrice(this.results.base + this.results.cpu + this.results.ram + this.results.storage) + ' ' + this.currency,
        }
         

        for (key in this.summary) {          
          const el = this.summaryBlock.querySelector(`[data-js-${key}]`)
          if (!el) continue;
          if (!this.summary[key]) {
            el.classList.add('d-none');
            continue
          }
          el.querySelector('.server-calc-info-item_value').innerHTML = this.summary[key]['title'];
          el.querySelector('.server-calc-info-item_price').innerHTML = this.summary[key]['price']
          el.classList.remove('d-none');    
        }
    }

    formatPrice(price) {
      // Определяем количество десятичных знаков
      const decimals = Number.isInteger(price) ? 0 : 2;
      return price.toFixed(decimals)
                .replace('.', ',')
                .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        // return new Intl.NumberFormat('ru-RU', {
        //     style: 'decimal',
        //     minimumFractionDigits: 2,
        //     maximumFractionDigits: 2
        // }).format(price);
    }

    debounce(func, timeout = 300) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }
}

// Инициализация при загрузке страницы и после AJAX-загрузки
document.addEventListener('DOMContentLoaded', () => new VPSCalculator());
document.addEventListener('getTarifLoadedCustomEvent', () => {
    // Переинициализируем при AJAX-загрузке
    vpsCalculatorInstance = new VPSCalculator();
});

function calcChangeOSradio(radioId) {  
  const radio = document.getElementById(radioId)
  const parent = radio.closest('.service-calc-group')
  parent.querySelectorAll('input[type="radio"]').forEach(radio => radio.removeAttribute('checked'))
  radio.setAttribute('checked', true)
  if (vpsCalculatorInstance) {
        // Вызываем метод calculate()
        vpsCalculatorInstance.calculate();
    }
}